import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const DAILY_CARDS = [
  {
    id: 1,
    title: "Clareza e Foco",
    category: "Mente & Calma",
    icon: "🧘",
    quote: "A mente quieta enxerga o que o barulho esconde.",
    tip: "Respire fundo 3 vezes seguidas inspirando pelo nariz e soltando pela boca antes de começar sua próxima tarefa. Isso reduz o cortisol e restaura seu foco.",
    action: "Faça 3 respirações conscientes agora.",
  },
  {
    id: 2,
    title: "Fluidez e Nutrição",
    category: "Corpo & Hidratação",
    icon: "💧",
    quote: "O corpo é seu templo diário; hidrate suas raízes.",
    tip: "Beber água em pequenos goles ao longo do dia é 3x mais eficiente do que beber grandes volumes de uma só vez.",
    action: "Encha seu copo de água agora mesmo.",
  },
  {
    id: 3,
    title: "Acolhimento Interior",
    category: "Autoestima & Motivação",
    icon: "🌸",
    quote: "Seja a sua primeira fonte de gentileza e paciência.",
    tip: "Não se cobre perfeição em dias cansativos. Fazer o que é possível com carinho por você mesmo já é uma vitória imensa.",
    action: "Repita para si: 'Estou fazendo o meu melhor'.",
  },
  {
    id: 4,
    title: "Pequenas Vitórias",
    category: "Rotina & Rituais",
    icon: "✨",
    quote: "Constância não é velocidade, é direção contínua.",
    tip: "Grandes transformações são feitas de 100 pequenas escolhas diárias. Lembre-se de tomar sua dose e marcar no aplicativo.",
    action: "Celebre um pequeno passo concluído hoje.",
  },
  {
    id: 5,
    title: "Desacelerar e Restaurar",
    category: "Mente & Calma",
    icon: "🌙",
    quote: "O descanso não é recompensa, é parte do caminho.",
    tip: "Reduza as luzes fortes e telas pelo menos 30 minutos antes de dormir. O seu sono determina a sua vitalidade do dia seguinte.",
    action: "Prepare um ambiente sereno para o seu sono.",
  },
];

const CATEGORIES = [
  { id: "TODOS", label: "Todas", icon: "✨" },
  { id: "Mente & Calma", label: "Mente & Calma", icon: "🧘" },
  { id: "Corpo & Hidratação", label: "Hidratação", icon: "💧" },
  { id: "Autoestima & Motivação", label: "Autoestima", icon: "🌸" },
  { id: "Rotina & Rituais", label: "Rotina", icon: "🌙" },
];

export default function Mystika() {
  const navigate = useNavigate();

  const [activeCategory, setActiveCategory] = useState("TODOS");
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [isRevealed, setIsRevealed] = useState(true);
  const [favorites, setFavorites] = useState([]);

  // Carregar favoritos do localStorage
  useEffect(() => {
    try {
      const stored = localStorage.getItem("mariam_mystika_favs");
      if (stored) {
        setFavorites(JSON.parse(stored));
      }
    } catch {
      // sem ação
    }
  }, []);

  const toggleFavorite = (cardId) => {
    const nextFavs = favorites.includes(cardId)
      ? favorites.filter((id) => id !== cardId)
      : [...favorites, cardId];

    setFavorites(nextFavs);
    try {
      localStorage.setItem("mariam_mystika_favs", JSON.stringify(nextFavs));
    } catch {
      // sem ação
    }
  };

  const handleDrawCard = () => {
    setIsRevealed(false);
    setTimeout(() => {
      const nextIdx = Math.floor(Math.random() * DAILY_CARDS.length);
      setCurrentCardIndex(nextIdx);
      setIsRevealed(true);
    }, 250);
  };

  const filteredCards =
    activeCategory === "TODOS"
      ? DAILY_CARDS
      : DAILY_CARDS.filter((c) => c.category === activeCategory);

  const activeCard = DAILY_CARDS[currentCardIndex];
  const isFav = favorites.includes(activeCard.id);

  return (
    <div className="space-y-4">
      {/* BOTÃO DE VOLTAR */}
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="inline-flex items-center gap-2 text-xs font-bold text-[#6C54D8] hover:text-[#24152F] transition-colors py-1 group"
      >
        <svg className="w-4 h-4 transition-transform group-hover:-translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
        </svg>
        Voltar
      </button>

      {/* HERO HEADER LITI */}
      <div className="liti-card p-5 shadow-sm border border-[#ECE7FA] space-y-2">
        <div className="flex items-center gap-3.5">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#6C54D8] text-white text-2xl shadow-xs font-bold">
            🔮
          </div>

          <div>
            <h1 className="text-xl font-bold text-[#24152F] font-serif tracking-tight">
              Mystika
            </h1>
            <p className="text-xs font-medium text-[#6D6680] mt-0.5">
              Inspirações, dicas de autocuidado e afirmações diárias
            </p>
          </div>
        </div>
      </div>

      {/* CARTA DO DIA / ORÁCULO INTERATIVO LITI */}
      <div className="liti-card p-5 sm:p-6 shadow-sm border border-[#ECE7FA] space-y-4">
        <div className="flex items-center justify-between">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider bg-[#ECE7FA] text-[#6C54D8]">
            ✨ Dica & Inspiração do Dia
          </span>

          <button
            type="button"
            onClick={() => toggleFavorite(activeCard.id)}
            className="p-1.5 text-amber-500 hover:scale-110 transition-transform text-lg cursor-pointer"
            title={isFav ? "Remover dos favoritos" : "Salvar nos favoritos"}
          >
            {isFav ? "★" : "☆"}
          </button>
        </div>

        {/* CARTA ANIMADA */}
        <div
          className={`transition-all duration-300 ${
            isRevealed ? "scale-100 opacity-100" : "scale-95 opacity-0"
          }`}
        >
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#ECE7FA] text-2xl">
              {activeCard.icon}
            </div>

            <div>
              <h2 className="text-lg font-bold text-[#24152F] font-serif">
                {activeCard.title}
              </h2>
              <span className="text-[11px] font-bold text-[#6C54D8]">
                {activeCard.category}
              </span>
            </div>
          </div>

          <p className="text-xs font-bold text-[#6C54D8] italic my-3 bg-[#ECE7FA]/60 p-3 rounded-2xl border border-[#ECE7FA]">
            "{activeCard.quote}"
          </p>

          <div className="rounded-2xl bg-white p-4 border border-[#ECE7FA] shadow-xs space-y-3">
            <p className="text-xs font-medium text-[#24152F] leading-relaxed">
              {activeCard.tip}
            </p>

            <div className="pt-2.5 border-t border-[#ECE7FA] flex flex-col sm:flex-row sm:items-center gap-1.5 text-xs font-bold text-[#6C54D8]">
              <span>💡 Sugestão de Ação:</span>
              <span className="text-[#24152F]">{activeCard.action}</span>
            </div>
          </div>
        </div>

        <button
          type="button"
          onClick={handleDrawCard}
          className="btn-primary w-full h-12 text-xs font-bold uppercase tracking-wider shadow-md flex items-center justify-center gap-2 mt-2"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          Sortear Nova Dica
        </button>
      </div>

      {/* SELETOR DE CATEGORIAS */}
      <div className="space-y-2 pt-1">
        <div className="flex items-center gap-2 px-1">
          <span className="h-2 w-2 rounded-full bg-[#6C54D8]" />
          <h3 className="text-xs font-bold text-[#24152F] uppercase tracking-wider">
            Explorar por Categoria
          </h3>
        </div>

        <div className="liti-card p-1.5 flex items-center gap-1.5 overflow-x-auto scrollbar-none shadow-xs">
          {CATEGORIES.map((cat) => {
            const isActive = activeCategory === cat.id;
            return (
              <button
                key={cat.id}
                type="button"
                onClick={() => setActiveCategory(cat.id)}
                className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-xs font-bold transition-all duration-200 shrink-0 cursor-pointer ${
                  isActive
                    ? "bg-[#6C54D8] text-white shadow-xs"
                    : "text-[#6D6680] hover:text-[#6C54D8] hover:bg-[#ECE7FA]/60"
                }`}
              >
                <span>{cat.icon}</span>
                <span>{cat.label}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* LISTA DE CARDS DE DICAS */}
      <div className="space-y-3">
        {filteredCards.map((card) => {
          const isSaved = favorites.includes(card.id);
          return (
            <div
              key={card.id}
              className="liti-card p-4 sm:p-5 shadow-xs border border-[#ECE7FA] space-y-2 transition-all duration-300 hover:-translate-y-0.5"
            >
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-3 min-w-0">
                  <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-[#ECE7FA] text-xl">
                    {card.icon}
                  </div>

                  <div className="min-w-0">
                    <h4 className="text-sm font-bold text-[#24152F] truncate font-serif">
                      {card.title}
                    </h4>
                    <span className="text-[11px] font-bold text-[#6C54D8]">
                      {card.category}
                    </span>
                  </div>
                </div>

                <button
                  type="button"
                  onClick={() => toggleFavorite(card.id)}
                  className="p-1.5 text-amber-500 hover:scale-110 transition-transform text-base cursor-pointer"
                >
                  {isSaved ? "★" : "☆"}
                </button>
              </div>

              <p className="text-xs font-medium text-[#6D6680] leading-relaxed pt-1">
                {card.tip}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}